// @ts-nocheck
import * as React from 'react';
import NoodleInput from 'components/uielements/Input';
import { formatFromNumberToMoney, addDecimals } from 'utils/formatConverters';
import { getMaskedValue } from 'utils/string';
import { formInputFormats } from 'commons/constants';
import type { FormatConverterOptions } from 'commons/types';
import type { FormInputEvent } from 'utils/form/Form.types';
import type { Mask } from 'utils/string/String.types';
import type { DefaultInputProps } from '../FormInput.types';

const { MONEY, PERCENTAGE, DEFAULT } = formInputFormats;
const formatConverters = {
  [DEFAULT]: ({ value }) => value,
  [MONEY]: formatFromNumberToMoney,
  [PERCENTAGE]: addDecimals,
};

const formatValue = (value?: string, format: string = DEFAULT, options?: FormatConverterOptions) =>
  formatConverters[format]({
    value,
    options,
  });

const handleOnChange =
  (onChange: (...args: Array<any>) => any, masks?: Mask[]) =>
  ({ currentTarget: { name, value } }: FormInputEvent): void => {
    onChange({
      currentTarget: {
        name,
        value: masks ? getMaskedValue(masks, value) : value,
      },
    });
  };

const renderDollarSign = (isCurrency: boolean): React.ReactElement<any> | null =>
  isCurrency ? <span className='form-input__dollar-sign'>$</span> : null;

const renderPercentageSign = (isPercentage: boolean): React.ReactElement<any> | null =>
  isPercentage ? <span className='form-input__percentage-sign'>%</span> : null;

const DefaultInput = ({
  disabled,
  format,
  formatOptions,
  inputClassName,
  inputType,
  masks,
  maxLength,
  max,
  min,
  name,
  noodleInputClass,
  onChange,
  onKeyPress,
  placeholder,
  step,
  value,
}: DefaultInputProps): React.ReactElement<any> => {
  const isCurrency = format === MONEY;
  const isPercentage = format === PERCENTAGE;
  const isPercentageClass = isPercentage ? 'percentage' : '';
  return (
    <div className={`${isPercentageClass} ${noodleInputClass}`}>
      {renderDollarSign(isCurrency)}
      {renderPercentageSign(isPercentage)}
      <NoodleInput
        className={inputClassName}
        disabled={disabled}
        maxLength={maxLength}
        max={max}
        min={min}
        name={name}
        onChange={handleOnChange(onChange, masks)}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        step={step}
        type={inputType}
        value={formatValue(value, format, formatOptions)}
      />
      <i className='fas' />
    </div>
  );
};

export default DefaultInput;
